var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00008 4.3335C5.44875 4.3335 5.00008 4.78216 5.00008 5.3335C5.00008 5.88483 5.44875 6.3335 6.00008 6.3335C6.55141 6.3335 7.00008 5.88483 7.00008 5.3335C7.00008 4.78216 6.55141 4.3335 6.00008 4.3335ZM6.00008 7.66683C4.71341 7.66683 3.66675 6.62016 3.66675 5.3335C3.66675 4.04683 4.71341 3.00016 6.00008 3.00016C7.28675 3.00016 8.33341 4.04683 8.33341 5.3335C8.33341 6.62016 7.28675 7.66683 6.00008 7.66683ZM6.00008 0.333496C3.05941 0.333496 0.666748 2.70283 0.666748 5.6155C0.666748 9.26483 5.36608 13.3348 5.56608 13.5062C5.69141 13.6135 5.84541 13.6668 6.00008 13.6668C6.15475 13.6668 6.30875 13.6135 6.43408 13.5062C6.63408 13.3348 11.3334 9.26483 11.3334 5.6155C11.3334 2.70283 8.94075 0.333496 6.00008 0.333496Z",
    fill: "#00A0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/IconLocation.f642f9891b87a40eac32d4e6b301a29b.svg";
export { ForwardRef as ReactComponent };